<template>
	<button
		class="mention-option"
		:class="{ disabled: user.deactivated_at }"
		:data-user="user.id"
		:data-fullname="user.fullname"
		:data-me="user.me || null"
	>
		<ProfilePic :user="user" size="24px" enableOnline onlineSize="10px" />
		<span class="mention-option-name">{{ user.fullname }}</span>
		<span
			class="mention-option-deactivated"
			v-if="user.deactivated_at"
			v-text="$t('admin_account_status_state_deactivated')"
		/>
	</button>
</template>

<script>
import { ProfilePic } from '../common'

export default {
	name: 'MentionSuggestion',
	props: ['user'],
	components: { ProfilePic },
}
</script>

<style lang="scss" scoped>
$highlight: var(--neutral-200);

.mention-option {
	cursor: pointer;
	display: flex;
	align-items: center;
	padding: 8px;
	margin: 0 4px 4px 0;
	width: 100%;
	background: inherit;
	border: none;
	border-radius: 12px;
	font-family: Avenir-Roman;
	font-size: 17px;
	color: var(--neutral-800);

	&.mention-active {
		background: $highlight;
	}
	&.disabled {
		opacity: 0.5;
		cursor: not-allowed;
		background: inherit !important;
	}
	&:last-child {
		margin-bottom: 0;
	}
	&.at-everyone {
		span {
			margin-left: 16px;
			color: var(--neutral-0);
		}
	}
	:deep(.profile-pic-avatar) {
		display: flex;
	}

	.mention-option-name {
		margin-left: 12px;
		overflow: hidden;
		max-width: 100%;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.mention-option-deactivated {
		margin-left: 12px;
		color: var(--neutral-400);
	}
}
</style>
